import { connect } from 'react-redux';
import Management from '../../components/management/Management';
import * as actions from '../../actions/management';

const mapStateToProps = ({ management }) => ({
  initialValues: {
    group: management.group[0] && management.group[0].gid,
    control: management.control[0] && management.control[0].typeid,
    faculty: management.faculty.length && management.faculty[0].idfaculty,
    cathedra: management.cathedra[0] && management.cathedra[0].idcathedra,
    academicYear: management.academicYear && management.academicYear[0].xp_key,
    academicPeriod: management.academicPeriod[0] && management.academicPeriod[0].trmid,
    discipline: (management.discipline[0] && management.discipline[0].cid) || '',
  },
  management,
  academicPeriodLoading: management.academicPeriodLoading,

  group: management.group,
  control: management.control,
  faculty: management.faculty,
  cathedra: management.cathedra,
  discipline: management.discipline,
  testResult: management.testResult,
  academicYear: management.academicYear,
  academicPeriod: management.academicPeriod,
  testResultPhotos: management.testResultPhotos,
});

const mapDispatchToProps = dispatch => ({
  didMount: () =>
    dispatch(actions.getAcademicYear())
    && dispatch(actions.getFaculty())
    && dispatch(actions.getFormOfControl()),
  getAcademicPeriod: yearId => dispatch(actions.getAcademicPeriod(yearId)),
  getCathedra: facultyId => dispatch(actions.getCathedra(facultyId)),
  getGroup: data => dispatch(actions.getGroup(data.faculty, data.cathedra, data.academicYear)),
  getDiscipline: data => dispatch(actions.getDiscipline(data.group, data.academicPeriod)),
  getTestResult: data =>
    dispatch(actions.getTestResult(data.academicPeriod, data.discipline, data.group, data.control)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Management);
